export const EXAMPLE_CLIENT_PHOTO_MODAL_NAME = 'exampleClientPhoto';
